function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E79637",
  d: "M9.97 5.55l-.1 7.14H8.75l-.1-7.14h1.33zM8.6 14.86c0-.2.06-.37.19-.52.12-.14.31-.2.56-.2.24 0 .42.06.55.2.13.15.2.32.2.52s-.07.37-.2.51-.31.21-.55.21c-.25 0-.44-.07-.56-.21a.74.74 0 01-.19-.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 10.5A9.5 9.5 0 119.5 1v1a8.5 8.5 0 108.5 8.5h1z"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#E79637",
  strokeWidth: 2,
  d: "M19 10.5A9.5 9.5 0 119.5 1v1a8.5 8.5 0 108.5 8.5h1z",
  mask: "url(#a)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#E79637",
  strokeLinecap: "round",
  d: "M6.81 1.88l1.03-.22.63-.1.67-.08m2.45.27l.97.3.96.39m1.51.94l.8.71.64.68m.95 1.42l.4.83.35.96m.33 2.61s0 1.05-.23 2.02"
});

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    fill: "none",
    viewBox: "0 0 19 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3c90fc76.svg";
export { ForwardRef as ReactComponent };